import type { EndpointMap } from '@zenos/front-end-util-types';

export const endpoints = {
  employeeDetails: '/v1/time-sheet/employee-details',
} satisfies EndpointMap;
